<template>
    <div class="c-gd-psla-calculator__psla-award">
        <h2>{{ award.case_name }}</h2>

        <div class="a-table--short-no-style">
            <table class="a-table a-table--full-width">
                <tr>
                    <td>Claimant Age at Trial/Deceased Age</td>
                    <td>{{ award.age_display }}</td>
                </tr>
                <tr>
                    <td>Updated PSLA Award (May 2017)</td>
                    <td class="c-gd-psla-calculator__award-container u-position-relative">
                        <div class="c-gd-psla-calculator__award">
                            {{ currencyFormat(award.award) }}
                        </div>
                        <button class="a-button a-button--smaller u-float-r"
                                @click="usePslaAward(award.award)" v-if="showButtons">
                            Use this PSLA Award
                        </button>
                    </td>
                </tr>
                <tr v-if="afterDate">
                    <td>Updated PSLA Award ({{ monthToString(maxMonth) }} {{ maxYear }})</td>
                    <td class="c-gd-psla-calculator__award-container u-position-relative">
                        <div class="c-gd-psla-calculator__award">
                            {{ currencyFormat(equivalent) }}
                        </div>
                        <button class="a-button a-button--smaller u-float-r"
                                @click="usePslaAward(equivalent)" v-if="showButtons">
                            Use this PSLA Award
                        </button>
                    </td>
                </tr>
                <tr>
                    <td>Duration of Symptoms</td>
                    <td>{{ award.duration }} month{{ award.duration===1?'':'s' }}</td>
                </tr>
                <tr>
                    <td>Reduction in Life Expectancy</td>
                    <td>{{ award.reduction_in_life }}</td>
                </tr>
                <tr>
                    <td valign="top">Effects of Injury</td>
                    <td>{{ award.effects }}</td>
                </tr>
            </table>
        </div>
    </div>
</template>
<script>
    import {mapActions, mapGetters} from 'vuex';
    import Moment from 'moment';
    import currencyFormat from 'mixins/currencyFormat';

    /**
     * Used to determine the life expectancy from a given "person"
     */
    export default {
        name: 'psla-award',
        props: {
            award: {
                type: Object,
                required: true
            },
            showButtons: {
                type: Boolean,
                default: true
            },
        },
        mixins: [
            currencyFormat
        ],
        mounted: function () {
            this.loadRpiData();
        },
        computed: {
            ...mapGetters('mini/inflation', ['rpiData']),
            rpi: {
                get() {
                    return this.rpiData;
                }
            },
            amount: {
                get() {
                    return this.award.award;
                }
            },
            maxYear: {
                get() {
                    return this.rpiYears[0];
                }
            },
            rpiYears: {
                get() {
                    let data = this.rpiData;

                    if (!data.length) {
                        return [];
                    }

                    return data.reduce(function (carry, item) {
                        if (!carry.length) {
                            carry = [];
                        }

                        if (!carry.includes(item.year)) {
                            carry.push(item.year);
                        }

                        return carry;
                    }).reverse();
                },
            },
            maxMonths: {
                get() {
                    let months = [];
                    for (let month = 1; month <= 12; month++) {
                        if (this.getRpiForDate(this.maxYear, month) !== 0) {
                            months.push(month);
                        }
                    }

                    return months.length;
                }
            },
            maxMonth: {
                get() {
                    return this.maxMonths;
                }
            },
            latestRPI: {
                get() {
                    return this.getRpiForDate(this.maxYear, this.maxMonth);
                }
            },
            equivalent: {
                get() {
                    return (this.amount / this.getRpiForDate(2017, 1) * this.getRpiForDate(this.maxYear, this.maxMonth));
                }
            },
            afterDate() {
                return Moment('01/'+this.maxMonth+'/'+this.maxYear, 'DD/M/YYYY').isAfter(Moment('01/05/2017', 'DD/MM/YYYY'));
            }
        },
        methods: {
            ...mapActions('mini/inflation', {
                loadRpiData: 'loadRpiData',
                updateValue: 'updateValue',
            }),
            ...mapActions('fatal/dependency/headsOfLoss', {updateHeadsOfLossValue: 'updateValue'}),
            ...mapActions('modal', ['toggle']),
            usePslaAward(value) {
                this.updateHeadsOfLossValue({key: 'generalDamages', value});
                this.toggle('generalDamagesPslaModal');
            },
            monthToString(value) {
                return Moment(value, 'M').format('MMMM');
            },
            getRpiForDate(year, month) {
                if (!this.rpi.length) {
                    return 0;
                }

                let rpi = this.rpi.reduce(function (carry, item) {
                    if (item.year === year && item.month === month) {
                        return item.amount;
                    }
                    return carry;
                });

                if (typeof rpi === 'object') {
                    return 0;
                }

                return rpi;
            },
        }
    }
</script>


// WEBPACK FOOTER //
// PslaAward.vue?4414ba56